// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'




import sdk from 'abdp.sdk';

import App from './App';
import router from '@/components/router';
import abdpConfig from './config.js';
//ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import iView from 'iview';
import 'iview/dist/styles/iview.css';

//引入弹出框的自定义新样式，覆盖掉的element-ui自带组件样式
import '@/assets/index.css'

Vue.use(iView)
Vue.use(ElementUI)
Vue.config.productionTip = false



// 构建全局Ajax对象
let ajaxManager=new sdk.AjaxManager({BaseUrl:abdpConfig.getApiServerPath()});
Vue.prototype.abdpAjax=ajaxManager;

//设置全局可访问的配置文件对象
Vue.prototype.abdpConfig =abdpConfig;

// 构建全局VarManager对象，实现缓存后台变量的功能
Vue.prototype.abdpVar=new sdk.VarManager({ajax:ajaxManager});

router.beforeEach((to, from, next) => {
  let isLogin = to.matched.some(record => record.meta.requiresAuth);
  let reg=/\&/g
  if (isLogin && !abdpConfig.getAuther()) {
    console.log("注意，main.js跳向登录页面");
      next({ path: '/login?to=' + to.fullPath.replace(reg,"$!") ,replace:true})
  }
  next()
})


new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js